import { action, observable } from "mobx";
import { replaceArrayContent } from "../utils/array.utils";
import { equalByJsonSnapshot } from "../utils/equality.utils";
import { copyWithJSON, mergeIntoObjectWithDescriptor } from "../utils/objects.utils";
import { isArray } from "../utils/typeChecks.utils";
export function makeFormField(originalSource, source, key, options) {
    var field = observable({
        keyName: key,
        get originalValue() {
            return originalSource[key];
        },
        get value() {
            return source[key];
        },
        set value(v) {
            if (isArray(source[key]) && isArray(v)) {
                replaceArrayContent(source[key], v);
            }
            else {
                source[key] = v;
            }
        },
        get validator() {
            return (options === null || options === void 0 ? void 0 : options.validators) ? options === null || options === void 0 ? void 0 : options.validators[key] : undefined;
        },
        get validity() {
            return field.validator ? field.validator(field.value) : true;
        },
        get changed() {
            return !equalByJsonSnapshot(field.originalValue, field.value);
        },
        touched: false,
        markAsTouched: action(function () { return field.touched = true; }),
        reset: action(function () { return field.value = field.originalValue; }),
        clear: action(function () { return field.value = undefined; }),
    });
    return field;
}
export function makeForm(object, options) {
    var _a;
    var originalSource = observable(copyWithJSON(object));
    var source = observable(copyWithJSON(object));
    var fields = observable({});
    Object.keys(source).forEach(function (key) {
        fields[key] = makeFormField(originalSource, source, key, options);
    });
    function mapFields(callback) {
        var result = {};
        Object.entries(fields).forEach(function (e) {
            result[e[0]] = callback(e[1]);
        });
        return result;
    }
    function iterator(callback) {
        Object.values(fields).forEach(callback);
    }
    var editableFieldNames = (_a = options === null || options === void 0 ? void 0 : options.editableFields) !== null && _a !== void 0 ? _a : Object.keys(fields);
    var editableFields = observable(editableFieldNames.map(function (n) { return fields[n]; }));
    var form = observable({
        fields: fields,
        get validity() {
            return mapFields(function (f) { return f.validity; });
        },
        clear: function () { return iterator(function (f) { return f.clear(); }); },
        reset: function (resetSource) {
            mergeIntoObjectWithDescriptor(source, copyWithJSON((resetSource !== null && resetSource !== void 0 ? resetSource : source)));
            mergeIntoObjectWithDescriptor(originalSource, copyWithJSON(source));
        },
        get value() {
            return source;
        },
        get: function (field) {
            var _a;
            return (_a = fields[field]) === null || _a === void 0 ? void 0 : _a.value;
        },
        set: action(function (field, value) {
            var formField = fields[field];
            return formField && (formField.value = value);
        }),
        get originalSource() {
            return copyWithJSON(originalSource);
        },
        editableFieldNames: editableFieldNames,
        editableFields: editableFields,
        get touched() {
            return editableFields.some(function (f) { return f.touched; });
        },
        checkIfHasChanges: function () {
            return editableFields.some(function (f) { return f.changed; });
        },
        get hasChanges() {
            return editableFields.some(function (f) { return f.changed; });
        },
        markAsSaved: function () {
            mergeIntoObjectWithDescriptor(originalSource, copyWithJSON(form.value));
        },
    });
    return form;
}
